const Colors = [
  '#E53935',
  '#D32F2F',  
  '#C62828',
  '#B71C1C',
  '#D81B60',
  '#C2185B',
  '#AD1457',
  '#880E4F',
  '#8E24AA',
  '#7B1FA2',
  '#6A1B9A',
  '#4A148C',
  '#3949AB',
  '#303F9F',
  '#283593',
  '#1A237E',
  '#1E88E5',
  '#1976D2',
  '#1565C0',
  '#039BE5',
  '#0288D1',
  '#01579B',
  '#43A047',
  '#388E3C',
  '#2E7D32',
  '#1B5E20',
  '#7CB342',
  '#689F38',
  '#558B2F',
  '#33691E',
  '#FB8C00',
  '#F57C00',  
  '#EF6C00', 
  '#E65100',

  ];

  export default Colors;